import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { communityObject } from '~/packages/geo/community/communityObject'
import { residenceImageObject } from './imageList/residenceImageList.definition'
import { citizenObject } from '../citizen/citizenObject'
import { latitude, longitude } from '~/prix/types/presets/geo'
import { ruralPropertyObject } from '~/packages/rural/ruralProperty/ruralPropertyObject'


export const residenceObject = z.object({
  id: z.string().uuid(),
  code: z.number(),
  plusCode: z.string(),
  title: z.string().nullish(),
  observation: z.string().nullish(),
  isRural: z.boolean().nullish(),
  monitoredLocation: z.boolean().nullish(),
  latitude: latitude(),
  longitude: longitude(),
  accuracy: z.number().nullish(),
  communityId: z.string().uuid().nullish(),
  community: communityObject.nullish(),
  ruralProperty: ruralPropertyObject.nullish(),
  images: z.array(residenceImageObject).nullish(),
  residents: z.array(citizenObject).nullish(),
  buildingId: z.number().nullish(),
  fullAddress: z.string().nullish(),
  complement: z.string().nullish(),
  referencePoint: z.string().nullish(),
  wifiSsid: z.string().nullish(),
  wifiPassword: z.string().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  residenceCustomCode: z.string().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  sourceFilter: z.string().nullish(),
})

export type ResidenceType = z.infer<typeof residenceObject>
